import { stripeClient } from "@better-auth/stripe/client";
import { adminClient, oneTapClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as
	| string
	| undefined;

export const authClient = createAuthClient({
	baseURL: import.meta.env.VITE_BETTER_AUTH_URL || "http://localhost:3000",
	fetchOptions: {
		credentials: "include",
	},
	plugins: [
		stripeClient({ subscription: true }),
		adminClient(),
		...(googleClientId
			? [
					oneTapClient({
						clientId: googleClientId,
						autoSelect: false,
						cancelOnTapOutside: true,
						context: "signin",
						additionalOptions: {
							color_scheme: "dark",
							itp_support: false,
						},
						promptOptions: {
							fedCM: false,
						},
					}),
				]
			: []),
	],
});

export const { signIn, signUp, signOut, useSession } = authClient;
